import type { ApiErrorBody } from "@majitap/ui";

/**
 * What staff read for an API error, by code. Codes the console knows get plain words; any other
 * shows the API's own message, which is written for people (CONVENTIONS.md). Field problems
 * (VALIDATION_FAILED) show under their fields, so the summary only points at them.
 */
const COPY: Record<string, string> = {
  NETWORK_ERROR: "The console can't reach MajiTap. Check your connection and try again.",
  API_UNAVAILABLE: "MajiTap isn't answering right now. Try again in a moment.",
  UNAUTHORIZED: "Your session has ended. Sign in again.",
  PERMISSION_DENIED: "Your role doesn't allow this. Ask an administrator if you need it.",
  WRONG_APP: "This session wasn't opened for the console. Sign out and sign in again.",
  COMPANY_NOT_SELECTED: "Choose a company first.",
  VALIDATION_FAILED: "Some fields need attention.",
  IDEMPOTENCY_KEY_REUSED: "This was already sent with different details. Check the form and send it again.",
  RATE_LIMITED: "Too many requests. Wait a moment and try again.",
  PAYOUT_SELF_APPROVAL: "You changed these payout details, so someone else must approve them.",
  REASON_CODE_TAKEN: "This list already has a reason with that name. Rename or restore that one instead.",
  STATUS_REASON_INVALID: "That reason can't be used here any more. Choose another one.",
};

export function messageFor(error: Pick<ApiErrorBody, "code" | "message"> | null | undefined): string {
  if (!error) return COPY.NETWORK_ERROR;
  return COPY[error.code] ?? error.message ?? COPY.NETWORK_ERROR;
}
